import { Container, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import PropertyFilterModal from "../components/PropertyFilter/PropertyFilterModal";
import PropertyOverviewListing from "../components/PropertyOverview/PropertyOverviewListing";
import { useListCollections } from "../hooks/properties/useListCollections";
import { usePropertySearch } from "../hooks/properties/usePropertySearch";
import { t } from "i18next";

const tabs = [
  {
    name: "properties",
    pageSize: 15,
  },
  {
    name: "collections",
    pageSize: 15,
  },
];

const PropertyOverview = () => {
  const [showMap, setShowMap] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState(15);
  const [pageIndex, setPageIndex] = useState(0);
  const [tempProps, setTempProps] = useState<any[] | []>([]);
  const [currentTab, setCurrentTab] = useState<any>(tabs[0]);
  const [items, setItems] = useState<any[]>([]);
  const [loadingItems, setLoadingItems] = useState<boolean>(false);
  const [filter, setFilter] = useState<any>({
    teamId: 1,
    pageIndex: pageIndex,
    pageSize: pageSize,
  });

  const { getDataByFilter: getPropertiesByFilter } = usePropertySearch();

  const { getDataByFilter: getCollectionsByFilter } = useListCollections();

  const [propertyCount, setPropertyCount] = useState(0);

  const switchTabs = (tabName: string) => {
    setPageIndex(0);
    setCurrentTab(tabs.find((tab) => tab.name === tabName));
    setShowMap(false);
  };

  const paginate = async (pageIndex: number) => {
    if (pageIndex * pageSize > propertyCount) return;

    const propertyFilter = {
      ...filter,
      pageSize,
      pageIndex,
    };

    const collectionFilter = {
      pageIndex,
      pageSize,
      teamId: 1,
    };

    try {
      setLoadingItems(true);
      setPageSize((currentTab?.pageSize as number) || 10);

      if (currentTab.name === "collections") {
        await getCollectionsByFilter(collectionFilter).then((result: any) => {
          setItems(result.collections);
          setPropertyCount(result.totalCollections);
          setLoadingItems(false);
        });
      }
      if (currentTab.name === "properties") {
        await getPropertiesByFilter(propertyFilter).then((result: any) => {
          setItems(result.properties);
          setPropertyCount(result.totalPropertiesCount);
          setLoadingItems(false);
        });
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  useEffect(() => {
    const loadingProperty: any = {
      propertyId: "1",
      title: "loading",
    };
    setPropertyCount(0);
    const loadingArray = [];

    for (let i = 0; i < pageSize; i++) {
      loadingArray.push(loadingProperty);
    }
    setTempProps(loadingArray);
  }, []);

  useEffect(() => {
    paginate(pageIndex);
  }, [pageIndex, filter, showMap, currentTab]);

  const handleApplyFilter = (newFilter: any) => {
    setPageIndex(0);
    setFilter({ ...newFilter, pageIndex: 0, teamId: 1 });
  };
  useEffect(() => {
    document.title = `${t("nav.property_listing")} - GoHome.rent`;
  }, []);

  return (
    <Container maxWidth={"xl"}>
      <Grid container spacing={4}>
        <Grid container item xs={12} md={3} position={"relative"}>
          <PropertyFilterModal
            onApplyFilter={handleApplyFilter}
            isLoading={loadingItems}
          />
        </Grid>
        <Grid container item xs={12} md={9} sx={{ alignContent: "flex-start" }}>
          <PropertyOverviewListing
            showMap={showMap}
            setShowMap={setShowMap}
            propertyCount={propertyCount}
            properties={items}
            propertyFilter={filter}
            loadingProperties={loadingItems}
            tempProps={tempProps}
            propertiesPerPage={pageSize}
            setPageIndex={setPageIndex}
            currentTab={currentTab}
            pageIndex={pageIndex}
            switchTabs={switchTabs}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default PropertyOverview;
